import React from 'react';
import './StatusNotification.css';

interface StatusNotificationProps {
  show: boolean;
  message: string;
  type?: 'info' | 'warning' | 'error';
}

const StatusNotification: React.FC<StatusNotificationProps> = ({
  show,
  message,
  type = 'info'
}) => {
  if (!show) return null;

  return (
    <div className={`status-notification status-notification-${type}`}>
      <div className="status-notification-content">
        {type === 'info' && <span className="status-icon">ℹ️</span>}
        {type === 'warning' && <span className="status-icon">⚠️</span>}
        {type === 'error' && <span className="status-icon">❌</span>}
        <span className="status-message">{message}</span>
      </div>
    </div>
  );
};

export default StatusNotification;